import React from 'react';
import SectionLiveTab from '../containers/SectionLiveTab/SectionLiveTab';
import 'css/LiveEventsPage.scss';
import 'css/HomePage.scss';

const LiveEventsPage = (props) => {
    return (
        <div className="live-event-page">
            <SectionLiveTab />
        </div>
    );
};

export default LiveEventsPage;
